import {styles} from "./Styles";
import {OnestNormalDefault} from "../../../styled/TextComponents";
import {BsXLg} from "react-icons/bs";
import {color_grey_dark} from "../../../../constants/colors";
import React from "react";
import { useI18n } from "../../../../i18n/I18nProvider";

export const WeeklyTaskModalRow = ({task, onTaskChange, onTaskDeleteClick, width}) => {
    const { t } = useI18n();
    return (
        <div style={{
            ...styles.weeklyTasksModalTaskContainer,
            width: width
        }}>
            <div style={{flexGrow: 1}}>
                    <textarea
                        value={task.title}
                        onChange={(e) => {
                            let newTaskData = {...task}
                            newTaskData.title = e.target.value
                            newTaskData.updated = true
                            onTaskChange(newTaskData)
                        }}
                        placeholder={t("Введите текст задачи")}
                        style={{
                            ...styles.weeklyTasksModalTextArea,
                            fontSize: 16,
                        }}
                    />
            </div>
            <div onClick={() => onTaskDeleteClick(task)}>
                <BsXLg style={{color: color_grey_dark}}/>
            </div>
        </div>
    )
}